import type { RedirectLoginOptions, LogoutUrlOptions } from "@auth0/auth0-spa-js";
import { type RouteLocationNormalizedGeneric } from "vue-router";

export const useAuth0 = () => {
  const { $auth0 } = useNuxtApp();

  const logout = async (options: LogoutUrlOptions) => {
    await $auth0.logout(options);
  };

  const getUser = async () => {
    return await $auth0.getUser();
  };

  const isAuthenticated = async () => {
    return await $auth0.isAuthenticated();
  };

  const getIdTokenClaims = async () => {
    return await $auth0.getIdTokenClaims();
  };

  const loginWithRedirect = async (options?: RedirectLoginOptions) => {
    await $auth0.loginWithRedirect(options);
  };

  const getTokenSilently = async () => {
    return await $auth0.getTokenSilently();
  };

  const handleRedirectCallback = async () => {
    return await $auth0.handleRedirectCallback();
  };

  const authenticate = async () => {
    // Check if the user is authenticated
    try {
      const token = await getTokenSilently();

      localStorage.setItem("auth0-token", token);
      return true;
    } catch (error) {
      return false;
    }
  };

  const anonymousRoutes = ["login", "auth"];

  const ensureAuthenticated = async (route: RouteLocationNormalizedGeneric) => {
    if (anonymousRoutes.includes(route.name as string)) {
      return;
    }

    const authenticated = await isAuthenticated();

    if (!authenticated) {
      return loginWithRedirect({
        appState: { targetUrl: route.fullPath },
      });
    }
  };

  return {
    logout,
    getUser,
    authenticate,
    isAuthenticated,
    getIdTokenClaims,
    loginWithRedirect,
    getTokenSilently,
    ensureAuthenticated,
    handleRedirectCallback,
  };
};
